import { AlertDialog } from "@components/ui/AlertDialog"
import { Button } from "@components/ui/Button"
import { useRPCQuery } from "eddev/hooks"
import { useAuth } from "../useAuth"
import { AreaSpinner } from "@components/ui/Spinner"
import { useRef, useState } from "react"
import { AnimatePresence, motion } from "motion/react"

type Props = {}

type CodeListItem = {
  label: string
  code: string
  note: string
}

export function MemberCodesDialog(props: Props) {
  const auth = useAuth()
  const accountLookup = useRPCQuery(
    "api.memberships.getAccount",
    { jwt: auth.session?.access_token! },
    {
      staleTime: 1,
      refetchInterval: 0,
      enabled: auth.loggedIn,
    },
  )

  return (
    <AlertDialog
      title="My Member Codes"
      description="See below for your membership discount codes"
      open
      canDismiss
      onOpenChange={(open) => {
        if (!open) {
          auth.closeModal()
        }
      }}
      confirmButton="Done"
      onCancel={() => {
        auth.closeModal()
      }}
      onConfirm={async () => {
        auth.closeModal()
      }}
    >
      <div className="stack-y-3">
        {accountLookup.isPending ? <AreaSpinner /> : null}
        {accountLookup.data?.codes.map((item, i) => (
          <div key={i} className="stack-y-1 border border-black/50 p-3 pt-4">
            <div className="type-label-m mb-1">{item.label}</div>
            <div className="type-body-xs opacity-50">{item.note}</div>
            <div className="type-label-xl mb-1">
              <CodeBox code={item.code} />
            </div>
          </div>
        ))}
      </div>
    </AlertDialog>
  )
}

function CodeBox(props: { code: string }) {
  const ref = useRef<HTMLInputElement>(null)
  const [label, setLabel] = useState("Click to copy")
  return (
    <div className="stack-y-2 items-start">
      <span
        ref={ref}
        className="bg-grey2 inline-flex pt-[0.3em] pb-[0.1em] px-[0.3em] cursor-pointer"
        onClick={() => {
          const el = ref.current!
          const range = document.createRange()
          range.selectNodeContents(el)
          const selection = window.getSelection()
          if (selection) {
            selection.removeAllRanges()
            selection.addRange(range)
          }
          navigator.clipboard
            .writeText(el.innerText)
            .catch((err) => {})
            .then(() => {
              setLabel("Copied!")
              setTimeout(() => {
                setLabel("Tap above to copy")
              }, 2000)
            })
        }}
      >
        {props.code}
      </span>
      <AnimatePresence>
        <motion.div className="type-label-xs" key={label} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          {label}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
